<div class="d-inline float-left">
	<div class="go-back" *ngIf="showBackButton">
		<a href="javascript:void(0)" (click)="returnToMainModule(500)">
			<i class="fas fa-arrow-left"></i>
			<span>{{title}}</span>
		</a>
	</div>
  	<div *ngIf="!showBackButton">{{ title }}</div>
</div>
